module.exports = __webpack_public_path__ + "static/img/service_content5-5_icon.d1687a4.png";